import React from 'react';
import { Outlet } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
export function Layout() {
  return <div className="min-h-screen flex flex-col bg-background font-sans text-gray-800" data-id="element-63">
      <Navbar data-id="element-64" />
      <main className="flex-grow" data-id="element-65">
        <Outlet data-id="element-66" />
      </main>
      <Footer data-id="element-67" />
    </div>;
}